import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { createdOrderFromForm } from "../../http/orderAPI"

export const fetchCreatedOrer = createAsyncThunk(
    'coin/fetchCreatedOrer',
    async function ({ game, name, server, price, coin, mail, user_id, payment_method }, { rejectWithValue, dispatch }) {
        dispatch(clearErrors())

        try {
            const data = await createdOrderFromForm(game, name, server, price, coin, mail, user_id, payment_method)
            return data

        } catch (error) {
            // если есть ответ от сервера
            if (error.response && error.response.data) {
                return rejectWithValue(error.response.data); 
            }
            return rejectWithValue({ message: error.message || 'Unknown error' });
        }
    }
)


const orderSlice = createSlice({
    name: 'order',
    initialState: {
        isLoading: false,
        error: null,
        data: null
    },
    reducers: {
        clearErrors(state) {
            state.error = null
            state.data = null
        }
    },
    extraReducers: builder => {
        builder

            .addCase(fetchCreatedOrer.pending, (state) => {
                state.isLoading = true
            })
            .addCase(fetchCreatedOrer.rejected, (state, action) => {
                state.isLoading = false;
            
                // Если rejectWithValue с сервером, данные будут в action.payload
                if (action.payload?.message) {
                    state.error = action.payload.message;
                } else {
                    // fallback на стандартное сообщение
                    state.error = action.error?.message || "Возникла ошибка!";
                }
            })
            .addCase(fetchCreatedOrer.fulfilled, (state, action) => {
                console.log(action.payload)
                state.isLoading = false
                state.data = action.payload.data
            })
    }
});

export const {
    clearErrors
} = orderSlice.actions;

export default orderSlice.reducer